export default {
  ESC: 27,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39
}



// WEBPACK FOOTER //
// ./src/utils/keycode.js